import Skybox from './Skybox';

export default Skybox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/claygl/src/plugin/Skydome.js
// module id = null
// module chunks = 